<template>
    <div class="card mb-4">
        <div class="card-header">
            <h2 class="card-title">
                {{ $t('cars.checkout.driver.panelTitle') }}
            </h2>
        </div>
        <div class="alert alert-secondary alert-flush">
            {{ $t('cars.checkout.driver.licenseNotice') }}
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group required">
                        <label for="driver_title" class="form-control-label">
                            {{ $t('cars.checkout.driver.title') }}
                        </label>
                        <select id="driver_title"
                                class="custom-select"
                                v-model="driver.title"
                                v-validate="'title'">
                            <option v-for="(title, key) in $t('cars.checkout.driver.titles', {returnObjects: true})"
                                    :value="key">{{ title }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group required">
                        <label for="driver_first_name" class="form-control-label">
                            {{ $t('cars.checkout.driver.firstName') }}
                        </label>
                        <input type="text"
                               id="driver_first_name"
                               class="form-control"
                               required
                               v-model="driver.firstName"
                               v-validate="'firstName'">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group required">
                        <label for="driver_first_name" class="form-control-label">
                            {{ $t('cars.checkout.driver.lastName') }}
                        </label>
                        <input type="text"
                               id="driver_last_name"
                               class="form-control"
                               required
                               v-model="driver.lastName"
                               v-validate="'lastName'">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group required">
                        <label for="driver_age" class="form-control-label">
                            {{ $t('cars.checkout.driver.age') }}
                        </label>
                        <select id="driver_age"
                                v-model="driver.age"
                                v-validate="'age'"
                                class="custom-select">
                            <option v-for="age in range(20, 99)" :value="age">{{ age }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label v-b-tooltip
                               for="driver_flight_number"
                               class="form-control-label"
                               :title="$t('cars.checkout.driver.flightTooltip')">
                            {{ $t('cars.checkout.driver.flight') }}
                            <i class="fa fa-question-circle"></i>
                        </label>
                        <input type="text"
                               id="driver_flight_number"
                               class="form-control"
                               placeholder="e.g. AA123"
                               v-model="driver.flightNumber"
                               v-validate="'flightNumber'">
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-8">
                    <div class="form-group required">
                        <label for="driver_phone_number" class="form-control-label">
                            {{ $t('cars.checkout.driver.phone') }}
                        </label>
                        <phone-number-form name="driver_phone"
                                           :phone="driver.phone"
                                           :required="true"
                                           :errors="errors ? errors.phone : null">
                        </phone-number-form>
                    </div>
                </div>
            </div>
            <address-form :name="driver"
                          :address="driver.address"
                          :errors="errors ? errors.address : null">
            </address-form>
        </div>
    </div>
</template>

<script>
    import PhoneNumberForm from '../../Misc/PhoneNumberForm';
    import AddressForm from '../../Misc/AddressForm';

    export default {
        name: 'DriverDetails',
        components: {
            AddressForm,
            PhoneNumberForm
        },
        props: ['searchParams', 'driver', 'errors'],
    };
</script>

<style scoped>

</style>